var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.admin === null)?_c('b-spinner',{attrs:{"type":"grow","label":"Loading..."}}):_c('RegularSettingsProfile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }